import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    getrefid,
    actualizarEstado,
    getUsuariomuetre,
    postparal,
    getorigenes,
    postorigenes,
    getorigenparal,
} from "../../../../redux/actions";
import { FaArrowLeft } from "react-icons/fa";
import styles from "./DetallesInboundParalleo.module.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import HashLoader from "react-spinners/HashLoader";
import { FaFileExcel, FaCheckCircle, FaPauseCircle, FaTimesCircle } from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Swal from "sweetalert2";

const DetallesInboundParalelo = () => {
    const location = useLocation();
    const referencia = location.state?.referencia || "Desconocida";
    const refidData = useSelector((state) => state.refid);
    const muestreadores = useSelector((state) => state.usuariomuetre?.usuarios || []);

    const registros = (location.state?.registros || refidData?.Registros || []).map(reg => ({
        ...reg,
        lote: reg.lote_num,
        origen: reg.origenparal,
    }));

    const [imagenSeleccionada, setImagenSeleccionada] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mostrarInfo, setMostrarInfo] = useState(false);
    const [mostrarLotesOficiales, setMostrarLotesOficiales] = useState(false);
    const [mostrarLotesParalelos, setMostrarLotesParalelos] = useState(false);
    const [mostrarDetallesModal, setMostrarDetallesModal] = useState(false);

    // ── Agregar Lote ──
    const [showAgregarLoteModal, setShowAgregarLoteModal] = useState(false);
    const [materialesParalelos, setMaterialesParalelos] = useState([]);
    const [registrado, setRegistrado] = useState("");
    const [nuevaFoto, setNuevaFoto] = useState(null);
    const [nuevoLoteData, setNuevoLoteData] = useState({
        placa: "", pesoneto: "", temp1: "", temp2: "", temp3: "", temp4: "",
        polucion: "Normal", observaciones: "", nom_material: "", Idusuariom: "",
        esNuevoOrigen: false, agregarParalelo: false, nuevoMaterial: "",
    });

    // ── Agregar Datos (vehículo) a lote existente ──
    const [showAgregarDatosModal, setShowAgregarDatosModal] = useState(false);
    const [fotoAgDatos, setFotoAgDatos] = useState(null);
    const [nuevosDatosLote, setNuevosDatosLote] = useState({
        placa: "", pesoneto: "", temp1: "", temp2: "", temp3: "", temp4: "",
        polucion: "Normal", observaciones: "", Idusuariom: "",
    });

    const registrosFiltrados = registros.filter(
        (reg) => reg.Idestado !== 1 && reg.lote && reg.origen
    );

    const { Idref } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [selectedLote, setSelectedLote] = useState(null);
    const [editRegistro, setEditRegistro] = useState(null);

    useEffect(() => {
        if (Idref) {
            setLoading(true);
            dispatch(getrefid(Idref)).then(() => {
                setTimeout(() => setLoading(false), 1000);
            });
            dispatch(getorigenparal(Idref)).then(data => {
                setMaterialesParalelos(data || []);
            });
        }
        dispatch(getUsuariomuetre());
        const userId = sessionStorage.getItem("id");
        if (userId) setRegistrado(userId);
    }, [dispatch, Idref]);

    // ─── Agrupaciones ───────────────────────────────────────────────────────
    const registrosParalelos = registrosFiltrados.filter(reg => reg.paral === 1);

    const origenes = registrosParalelos.reduce((acc, reg) => {
        const origen = reg.origenparal || "Desconocido";
        const lote = reg.lote_num != null ? reg.lote_num.toString() : "0";
        if (!acc[origen]) acc[origen] = {};
        if (!acc[origen][lote]) acc[origen][lote] = [];
        acc[origen][lote].push(reg);
        return acc;
    }, {});

    const lotes = registros.reduce((acc, reg) => {
        const lote = reg.lote_num != null ? reg.lote_num.toString() : "0";
        if (!acc[lote]) acc[lote] = [];
        acc[lote].push(reg);
        return acc;
    }, {});

    // Lotes Oficiales
    const lotesProcesados = Object.keys(lotes).map((lote) => {
        const registrosLote = lotes[lote];
        registrosLote.sort((a, b) => new Date(b.fechacompleta) - new Date(a.fechacompleta));
        const ultimo = registrosLote[0];
        const acumuladoLote = registrosLote.reduce((s, r) => s + Number(r.pesoneto || 0), 0);
        return { lote, fechaUltima: ultimo.fechacompleta, estado: ultimo.Idestado, descripcion_estado: ultimo.descripcion_estado, registros: registrosLote, cantidadRegistros: registrosLote.length, acumuladoLote, Idorigen: ultimo.Idorigen, paral: 0 };
    }).filter(({ registros: regs, estado }) => !(regs.length === 1 && estado === 1));

    // Mapa estados oficiales para sincronizar paralelos
    const mapaEstadosOficiales = lotesProcesados.reduce((acc, l) => {
        acc[l.lote] = { estado: l.estado, descripcion_estado: l.descripcion_estado };
        return acc;
    }, {});

    // Lotes Paralelos sincronizados
    const origenesProcesados = Object.entries(origenes).map(([nombreOrigen, lotesParOrigen]) => {
        const lotesArray = Object.entries(lotesParOrigen).map(([lote, registrosLote]) => {
            registrosLote.sort((a, b) => new Date(b.fechacompleta) - new Date(a.fechacompleta));
            const ultimo = registrosLote[0];
            const acumuladoLote = registrosLote.reduce((s, r) => s + Number(r.pesoneto || 0), 0);
            const estadoOficial = mapaEstadosOficiales[lote]; // 🔑 Sincronización
            return {
                lote, registros: registrosLote, fechaUltima: ultimo.fechacompleta,
                estado: estadoOficial ? estadoOficial.estado : ultimo.Idestado,
                descripcion_estado: estadoOficial ? estadoOficial.descripcion_estado : ultimo.descripcion_estado,
                cantidadRegistros: registrosLote.length, acumuladoLote,
                origenparal: nombreOrigen, Idorigen: ultimo.Idorigen, paral: 1,
            };
        });
        return { nombreOrigen, lotes: lotesArray };
    });

    // ─── Helpers (extraídos de LoteDetailParalelo RN) ────────────────────────
    const getSpecificPlan = (loteData) => {
        if (!loteData || !refidData) return refidData?.Planmuestreo || {};
        const specificIdPlan = loteData.registros?.[0]?.Idplan;
        return (refidData?.PlanesMuestreo || []).find(p => p.id === specificIdPlan) || refidData?.Planmuestreo || {};
    };

    const isBotonDeshabilitado = (estado) => {
        const d = (estado || "").toString();
        return d === "6" || d === "4" || d === "3" || d === "Lote cerrado" || d === "Cancelado" || d === "En pausa";
    };

    const obtenerEstadoConfig = (descripcion) => {
        switch (descripcion) {
            case "Lote cerrado": return { color: "#38a169", bg: "#f0fff4" };
            case "Cancelado": return { color: "#e53e3e", bg: "#fff5f5" };
            case "En pausa": return { color: "#dd6b20", bg: "#fffaf0" };
            case "En curso": return { color: "#6c5dd3", bg: "#f3f0ff" };
            default: return { color: "#718096", bg: "#f7fafc" };
        }
    };

    // ─── Handlers ────────────────────────────────────────────────────────────
    const handleOpenModal = (lote) => {
        setMostrarDetallesModal(false);
        setSelectedLote(lote);
    };

    const handleCloseModal = () => {
        setSelectedLote(null);
        setEditRegistro(null);
    };

    const handleCellClick = (registro) => {
        setEditRegistro({ ...registro });
    };

    const handleCloseEditModal = () => setEditRegistro(null);

    const handleSaveEdit = (e) => {
        e.preventDefault();
        setEditRegistro(null);
    };

    const acomuladoTotal = registros.reduce((sum, reg) => sum + Number(reg.pesoneto || 0), 0);

    const ultimoRegistroGeneral = registros.reduce((ultimo, reg) => {
        return !ultimo || new Date(reg.fechacompleta) > new Date(ultimo.fechacompleta) ? reg : ultimo;
    }, null);

    const estadoGeneral = ultimoRegistroGeneral ? ultimoRegistroGeneral.descripcion_estado : "Desconocido";

    // Lote oficial con el número más alto (el "último" lote activo)
    const loteMayor = lotesProcesados.length > 0
        ? Math.max(...lotesProcesados.map(l => Number(l.lote)))
        : 0;

    const hayLoteEnCurso = lotesProcesados.some(l => Number(l.estado) === 2);
    const mostrarBotonAgregar = estadoGeneral === "Creado" || estadoGeneral === "Lote cerrado" || estadoGeneral === "En curso";


    const handleGuardarNuevoOrigen = async () => {
        const nombre = nuevoLoteData.nuevoMaterial;
        if (!nombre?.trim()) return Swal.fire("Aviso", "Ingrese el nombre del nuevo origen", "warning");
        try {
            const res = await dispatch(postorigenes({ nombre: nombre.trim().toUpperCase(), Idref: Number(Idref) }));
            if (res) {
                Swal.fire("¡Éxito!", "Origen guardado", "success");
                setNuevoLoteData(p => ({ ...p, esNuevoOrigen: false, nom_material: nombre.trim().toUpperCase(), nuevoMaterial: "" }));
                const data = await dispatch(getorigenparal(Idref));
                setMaterialesParalelos(data || []);
            }
        } catch (err) {
            Swal.fire("Error", err.response?.data?.error || "Error", "error");
        }
    };


    const handleAgregarNuevoLote = async (e) => {
        e.preventDefault();

        const origenNombre = nuevoLoteData.esNuevoOrigen
            ? nuevoLoteData.nuevoMaterial.trim().toUpperCase()
            : nuevoLoteData.nom_material;

        if (!origenNombre) {
            return Swal.fire("Error", "Seleccione o ingrese un origen", "error");
        }
        if (!registrado) {
            return Swal.fire("Error", "No se detectó el usuario registrador. Recargue la página.", "error");
        }

        // Buscar el ID numérico del origen seleccionado
        const origenObj = materialesParalelos.find(m => m.origenparal === origenNombre);
        const idmaterial = origenObj?.id || origenObj?.Idorigen || "";

        // Plan a usar (el más reciente)
        const planapptual = refidData?.PlanesMuestreo?.[0]?.id || refidData?.Planmuestreo?.id || "";
        if (!planapptual) {
            return Swal.fire("Error", "No se encontró el plan de muestreo de esta referencia", "error");
        }

        setLoading(true);
        const ahora = new Date();
        const fechacompleta = `${ahora.toISOString().split("T")[0]} ${ahora.toTimeString().split(" ")[0].substring(0, 5)}:00.000-05`;

        const formData = new FormData();
        formData.append("fechacompleta", fechacompleta);
        formData.append("fechaflag", "1");          // ← Usar la fecha enviada
        formData.append("Idref", Number(Idref));
        formData.append("placa", nuevoLoteData.placa.trim().toUpperCase());
        formData.append("pesoneto", nuevoLoteData.pesoneto);
        formData.append("temp1", nuevoLoteData.temp1 || "");
        formData.append("temp2", nuevoLoteData.temp2 || "");
        formData.append("temp3", nuevoLoteData.temp3 || "");
        formData.append("temp4", nuevoLoteData.temp4 || "");
        formData.append("polucion", nuevoLoteData.polucion);
        formData.append("observaciones", nuevoLoteData.observaciones);
        formData.append("Idestado", "2");
        formData.append("Idusuariom", nuevoLoteData.Idusuariom);
        formData.append("Idusuarior", registrado);  // ID del usuario logueado
        formData.append("newlot", "2");              // ← Indica nuevo lote
        formData.append("planapptual", planapptual); // ← Nombre correcto para el backend
        formData.append("idmaterial", idmaterial);   // ← ID numérico del origen (Idorigen)
        formData.append("nom_material", origenNombre);
        formData.append("origenparal", origenNombre);
        if (nuevoLoteData.agregarParalelo) formData.append("paral", "1");
        if (nuevaFoto) formData.append("fototick", nuevaFoto);

        try {
            const res = await dispatch(postparal(formData));
            if (res?.success || res?.message === "Registro actualizado correctamente" || res?.id || res?.registro) {
                Swal.fire({ icon: "success", title: "Lote iniciado", timer: 1500, showConfirmButton: false });
                setShowAgregarLoteModal(false);
                setNuevoLoteData({ placa: "", pesoneto: "", temp1: "", temp2: "", temp3: "", temp4: "", polucion: "Normal", observaciones: "", nom_material: "", Idusuariom: "", esNuevoOrigen: false, agregarParalelo: false, nuevoMaterial: "" });
                setNuevaFoto(null);
                dispatch(getrefid(Idref));
            } else {
                Swal.fire("Error", res?.error || "Error desconocido al crear lote", "error");
            }
        } catch (err) {
            Swal.fire("Error", err.response?.data?.error || err.message, "error");
        } finally {
            setLoading(false);
        }
    };


    // 🔹 Agregar vehículo a lote existente (AgregarDatosLoteParalelo RN)
    const handleAgregarDatos = async (e) => {
        e.preventDefault();
        if (!selectedLote) return;
        if (!registrado) {
            return Swal.fire("Error", "No se detectó el usuario registrador. Recargue la página.", "error");
        }

        // ID numérico del origen del lote seleccionado
        const idmaterial = selectedLote.Idorigen || "";

        // Plan del primer registro del lote, o el plan más reciente de la referencia
        const planapptual = selectedLote.registros?.[0]?.Idplan
            || refidData?.PlanesMuestreo?.[0]?.id
            || refidData?.Planmuestreo?.id
            || "";

        if (!planapptual) {
            return Swal.fire("Error", "No se encontró el plan de muestreo para este lote", "error");
        }

        setLoading(true);
        const ahora = new Date();
        const fechacompleta = `${ahora.toISOString().split("T")[0]} ${ahora.toTimeString().split(" ")[0].substring(0, 5)}:00.000-05`;

        const formData = new FormData();
        formData.append("fechacompleta", fechacompleta);
        formData.append("fechaflag", "1");           // ← Usar la fecha enviada
        formData.append("Idref", Number(Idref));
        formData.append("placa", nuevosDatosLote.placa.trim().toUpperCase());
        formData.append("pesoneto", nuevosDatosLote.pesoneto);
        formData.append("temp1", nuevosDatosLote.temp1 || "");
        formData.append("temp2", nuevosDatosLote.temp2 || "");
        formData.append("temp3", nuevosDatosLote.temp3 || "");
        formData.append("temp4", nuevosDatosLote.temp4 || "");
        formData.append("polucion", nuevosDatosLote.polucion);
        formData.append("observaciones", nuevosDatosLote.observaciones);
        formData.append("Idestado", "2");
        formData.append("Idusuariom", nuevosDatosLote.Idusuariom);
        formData.append("Idusuarior", registrado);   // ← ID del usuario logueado
        // Sin newlot → el backend agrega al lote en curso
        formData.append("planapptual", planapptual); // ← Nombre correcto para el backend
        formData.append("idmaterial", idmaterial);   // ← ID numérico del origen
        formData.append("nom_material", selectedLote.origenparal || "");
        formData.append("origenparal", selectedLote.origenparal || "");
        if (selectedLote.paral === 1) formData.append("paral", "1");
        if (fotoAgDatos) formData.append("fototick", fotoAgDatos);

        try {
            const res = await dispatch(postparal(formData));
            if (res?.success || res?.message === "Registro actualizado correctamente" || res?.id || res?.registro) {
                Swal.fire({ icon: "success", title: "Vehículo registrado", timer: 1500, showConfirmButton: false });
                setShowAgregarDatosModal(false);
                setNuevosDatosLote({ placa: "", pesoneto: "", temp1: "", temp2: "", temp3: "", temp4: "", polucion: "Normal", observaciones: "", Idusuariom: "" });
                setFotoAgDatos(null);
                dispatch(getrefid(Idref));
                setSelectedLote(null);
            } else {
                Swal.fire("Error", res?.error || "Error desconocido al registrar vehículo", "error");
            }
        } catch (err) {
            Swal.fire("Error", err.response?.data?.error || err.message, "error");
        } finally {
            setLoading(false);
        }
    };


    const exportarAExcel = () => {
        const registrosOrdenados = selectedLote.registros.slice().sort((a, b) => new Date(a.fechacompleta) - new Date(b.fechacompleta));
        let acumulado = 0;
        const data = registrosOrdenados.map((reg) => {
            acumulado += Number(reg.pesoneto || 0);
            return { Fecha: new Date(reg.fechacompleta).toISOString().split("T")[0], Hora: new Date(reg.fechacompleta).toLocaleTimeString("es-ES"), Placa: reg.placa || "N/A", "Peso Neto (t)": reg.pesoneto, "Acumulado (t)": acumulado.toFixed(2), Temp1: reg.temp1, Temp2: reg.temp2, Temp3: reg.temp3, Temp4: reg.temp4, Máx: reg.MaxTemp, Mín: reg.MinTemp, Polución: reg.polucion, origen: reg.origenparal, Muestreado: reg.nombre_usuario_m, Registrado: reg.nombre_usuario_r, Observaciones: reg.observaciones };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Registros");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        saveAs(new Blob([excelBuffer], { type: "application/octet-stream" }), `Lote_${selectedLote.lote}_Referencia_${referencia}.xlsx`);
    };

    const formatearFechaHora = (fechaStr) => {
        const f = new Date(fechaStr);
        return `${f.getFullYear()}-${String(f.getMonth() + 1).padStart(2, '0')}-${String(f.getDate()).padStart(2, '0')} ${String(f.getHours()).padStart(2, '0')}:${String(f.getMinutes()).padStart(2, '0')}:${String(f.getSeconds()).padStart(2, '0')}`;
    };

    if (loading) {
        return (
            <div className={styles.loaderContainer}>
                <HashLoader color="#3559d1" size={60} />
                <p>Cargando datos espere...</p>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={() => navigate("/inbound")}>
                <FaArrowLeft className={styles.icon} /> Volver
            </button>

            <h2>Detalles de Inbound paralelo - Referencia {referencia}</h2>

            <div className={styles.infoContainer}>
                <button className={styles.toggleButton} onClick={() => setMostrarInfo(!mostrarInfo)}>
                    {mostrarInfo ? '− Ocultar Detalles' : '+ Mostrar Detalles'}
                </button>
                {mostrarInfo && (
                    <div className={styles.infoGrid}>
                        <div><strong>Cliente:</strong> {refidData.cliente}</div>
                        <div><strong>Ubicación:</strong> {refidData.ubicacion}</div>
                        <div><strong>Lugar:</strong> {refidData.lugar}</div>
                        <div><strong>Material:</strong> {refidData.material}</div>
                        <div><strong>Tonelaje total:</strong> {refidData.tonelaje_total} t</div>
                        <div><strong>Tamaño Material:</strong> {refidData.tamano_mate}</div>
                        <div><strong>Promedio bolsas por lote:</strong> {Math.round(refidData.bolsa)}</div>
                        <div><strong>Acumulado Total:</strong> {acomuladoTotal.toFixed(2)} t</div>
                        <div><strong>Estado General:</strong> {estadoGeneral}</div>
                    </div>
                )}
            </div>

            {/* Botón Agregar Lote */}
            {mostrarBotonAgregar && (
                <button
                    className={styles.addLoteButton}
                    onClick={() => !hayLoteEnCurso && setShowAgregarLoteModal(true)}
                    disabled={hayLoteEnCurso}
                    style={hayLoteEnCurso ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                    title={hayLoteEnCurso ? "Cierre el lote actual para agregar uno nuevo" : "Agregar nuevo lote"}
                >
                    + Agregar Lote {hayLoteEnCurso && "(Cierre el lote actual)"}
                </button>
            )}
            <br /><br /><br />

            {/* ═══ Lotes Oficiales ═══ */}
            <h3 className={styles.tituloLotesOficiales} onClick={() => setMostrarLotesOficiales(prev => !prev)}>
                Lotes Oficiales
                {mostrarLotesOficiales ? <FaChevronUp style={{ marginLeft: "8px" }} /> : <FaChevronDown style={{ marginLeft: "8px" }} />}
            </h3>

            {mostrarLotesOficiales && (
                <div className={styles.cardsContainercard}>
                    {lotesProcesados.map((loteData) => (
                        <div key={loteData.lote} className={styles.card} onClick={() => handleOpenModal(loteData)}>
                            <h4>Lote {loteData.lote}</h4>
                            <p><strong>Última Fecha:</strong> {formatearFechaHora(loteData.fechaUltima)}</p>
                            <p><strong>Estado:</strong> {loteData.descripcion_estado}</p>
                            <p><strong>Acumulado:</strong> {loteData.acumuladoLote.toFixed(2)} t</p>
                        </div>
                    ))}
                </div>
            )}

            {/* ═══ Lotes Paralelos ═══ */}
            {origenesProcesados.length > 0 && (
                <>
                    <h3 className={styles.tituloLotesParalelos} onClick={() => setMostrarLotesParalelos(prev => !prev)}>
                        Lotes Paralelos
                        {mostrarLotesParalelos ? <FaChevronUp style={{ marginLeft: "8px" }} /> : <FaChevronDown style={{ marginLeft: "8px" }} />}
                    </h3><br />

                    {mostrarLotesParalelos && origenesProcesados.map((origen) => (
                        <div key={origen.nombreOrigen} className={styles.origenSection}>
                            <h4>
                                <span style={{ color: "#d26d5e", fontWeight: "bold" }}>Origen:</span>{" "}
                                <span style={{ color: "#2f6589ff" }}>{origen.nombreOrigen}</span>
                            </h4>
                            <div className={styles.cardsContainercard}>
                                {origen.lotes.map((loteData) => (
                                    <div key={loteData.lote} className={styles.card} onClick={() => handleOpenModal(loteData)}>
                                        <h5>Lote {loteData.lote}</h5>
                                        <p><strong>Última Fecha:</strong> {formatearFechaHora(loteData.fechaUltima)}</p>
                                        <p><strong>Estado:</strong> {loteData.descripcion_estado}</p>
                                        <p><strong>Acumulado:</strong> {loteData.acumuladoLote.toFixed(2)} t</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </>
            )}

            {/* ═══ MODAL DETALLE LOTE (estilo LoteDetailParalelo RN) ═══ */}
            {selectedLote && (() => {
                const plan = getSpecificPlan(selectedLote);
                const factor = parseFloat(plan?.Factorcarga?.factor || plan?.factor || 1);
                const tamLot = parseFloat(plan?.tamano_lote || refidData?.tamano_lot || 0);
                const cantveh = tamLot > 0 && factor > 0 ? Math.ceil(tamLot / factor) : (refidData?.Cantidad_veh || 0);
                const frecCalidad = parseFloat(plan?.frecuencia_calidad || 0);
                const frecGranul = parseFloat(plan?.frecuencia_granulometria || 0);
                const frec1 = parseFloat(plan?.frecuencia_1 || 0);
                const increBolsa = parseFloat(plan?.incremento_bolsa || 1);
                const bolsa = ((frecCalidad * cantveh) + (frecGranul * cantveh) + (frec1 * cantveh)) / increBolsa;

                const regsOrdenados = [...(selectedLote.registros || [])].sort((a, b) => new Date(a.fechacompleta) - new Date(b.fechacompleta));
                const maxTemp = Math.max(0, ...regsOrdenados.map(r => parseFloat(r.MaxTemp) || 0));
                const minTemp = regsOrdenados.length > 0
                    ? Math.min(...regsOrdenados.filter(r => r.MinTemp != null).map(r => parseFloat(r.MinTemp) || 0))
                    : 0;
                const totalAcumulado = regsOrdenados.reduce((s, r) => s + Number(r.pesoneto || 0), 0).toFixed(2);
                const estadoConf = obtenerEstadoConfig(selectedLote.descripcion_estado);
                const deshabilitado = isBotonDeshabilitado(selectedLote.estado || selectedLote.descripcion_estado);

                return (
                    <div className={styles.modalOverlay}>
                        <div className={styles.modal}>
                            {/* Header */}
                            <div className={styles.encabezadoModal}>
                                <button className={styles.closeButton} onClick={handleCloseModal}>X</button>
                                <h2>
                                    Detalle Lote {selectedLote.lote}
                                    {selectedLote.paral === 1 ? ` — Paralelo (${selectedLote.origenparal})` : " — Oficial"}
                                </h2>
                            </div>

                            {/* Summary Card */}
                            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px", padding: "16px", margin: "0 0 14px 0" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
                                    <div>
                                        <p style={{ fontWeight: "700", fontSize: "15px", color: "#1a202c", margin: 0 }}>Referencia: {referencia}</p>
                                        {selectedLote.paral === 1 && (
                                            <p style={{ color: "#6c5dd3", fontSize: "13px", margin: "2px 0 0 0" }}>Origen: {selectedLote.origenparal}</p>
                                        )}
                                    </div>
                                    <span style={{ background: estadoConf.bg, color: estadoConf.color, border: `1px solid ${estadoConf.color}40`, borderRadius: "20px", padding: "4px 12px", fontSize: "12px", fontWeight: "700" }}>
                                        {selectedLote.descripcion_estado}
                                    </span>
                                </div>

                                {/* Stats */}
                                <div style={{ display: "flex", gap: "12px", marginBottom: "10px" }}>
                                    <div style={{ flex: 1, background: "white", borderRadius: "8px", padding: "10px 14px", borderLeft: "4px solid #6c5dd3" }}>
                                        <p style={{ margin: 0, fontSize: "11px", color: "#718096", fontWeight: "600", textTransform: "uppercase" }}>Acumulado</p>
                                        <p style={{ margin: "4px 0 0", fontSize: "20px", fontWeight: "800", color: "#1a202c" }}>{totalAcumulado} <span style={{ fontSize: "13px", color: "#718096" }}>t</span></p>
                                    </div>
                                    <div style={{ flex: 1, background: "white", borderRadius: "8px", padding: "10px 14px", borderLeft: "4px solid #38a169" }}>
                                        <p style={{ margin: 0, fontSize: "11px", color: "#718096", fontWeight: "600", textTransform: "uppercase" }}>Objetivo Lote</p>
                                        <p style={{ margin: "4px 0 0", fontSize: "20px", fontWeight: "800", color: "#1a202c" }}>{tamLot || "---"} <span style={{ fontSize: "13px", color: "#718096" }}>t</span></p>
                                    </div>
                                    <div style={{ flex: 1, background: "white", borderRadius: "8px", padding: "10px 14px", borderLeft: "4px solid #dd6b20" }}>
                                        <p style={{ margin: 0, fontSize: "11px", color: "#718096", fontWeight: "600", textTransform: "uppercase" }}>Vehículos</p>
                                        <p style={{ margin: "4px 0 0", fontSize: "20px", fontWeight: "800", color: "#1a202c" }}>{selectedLote.cantidadRegistros} <span style={{ fontSize: "13px", color: "#718096" }}>/ {cantveh}</span></p>
                                    </div>
                                </div>

                                {/* Temps */}
                                <div style={{ display: "flex", gap: "16px" }}>
                                    <span style={{ fontSize: "13px", color: "#e53e3e", fontWeight: "600" }}>🌡 Máx: {maxTemp.toFixed(1)}°C</span>
                                    <span style={{ fontSize: "13px", color: "#3182ce", fontWeight: "600" }}>🌡 Mín: {minTemp.toFixed(1)}°C</span>
                                </div>
                            </div>

                            {/* Action Buttons — con lógica de visibilidad por tipo de lote */}
                            {(() => {
                                const esParalelo = selectedLote.paral === 1;
                                const esUltimoLote = !esParalelo && Number(selectedLote.lote) === loteMayor;
                                // Paralelos: nunca muestran botones
                                // Oficial NO último y cerrado: tampoco
                                // Oficial último: siempre (deshabilitados si cerrado)
                                // Oficial NO último abierto: botones activos
                                const mostrarBotones = !esParalelo && (esUltimoLote || !deshabilitado);

                                if (!mostrarBotones) return null;

                                return (
                                    <div className={styles.actionButtons} style={{ marginBottom: "12px" }}>
                                        {/* Agregar Vehículo */}
                                        <button
                                            onClick={() => setShowAgregarDatosModal(true)}
                                            disabled={deshabilitado}
                                            style={{
                                                background: deshabilitado ? "#a0aec0" : "linear-gradient(135deg, #6c5dd3, #4f46e5)",
                                                color: "white", border: "none", borderRadius: "8px",
                                                padding: "10px 18px", fontWeight: "700", fontSize: "14px",
                                                cursor: deshabilitado ? "not-allowed" : "pointer",
                                                display: "flex", alignItems: "center", gap: "6px",
                                                opacity: deshabilitado ? 0.5 : 1,
                                            }}
                                            title={deshabilitado ? "El lote debe estar En curso para agregar vehículos" : "Agregar vehículo al lote actual"}
                                        >
                                            ➕ Agregar Vehículo
                                        </button>
                                        <button className={styles.closeLoteButton} disabled={deshabilitado} style={deshabilitado ? { opacity: 0.4, cursor: "not-allowed" } : {}}>
                                            <FaCheckCircle className={styles.iconButton} /> Cerrar Lote
                                        </button>
                                        <button className={styles.pauseButton} disabled={deshabilitado} style={deshabilitado ? { opacity: 0.4, cursor: "not-allowed" } : {}}>
                                            <FaPauseCircle className={styles.iconButton} /> Pausar
                                        </button>
                                        <button className={styles.cancelButton} disabled={deshabilitado} style={deshabilitado ? { opacity: 0.4, cursor: "not-allowed" } : {}}>
                                            <FaTimesCircle className={styles.iconButton} /> Cancelar
                                        </button>
                                    </div>
                                );
                            })()}


                            {/* Especificaciones (colapsable) */}
                            <button
                                onClick={() => setMostrarDetallesModal(prev => !prev)}
                                style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f3f0ff", border: "1px solid #c4b5fd", borderRadius: "8px", padding: "10px 14px", cursor: "pointer", marginBottom: "12px", fontWeight: "700", color: "#6c5dd3" }}
                            >
                                <span>Especificaciones del Lote</span>
                                {mostrarDetallesModal ? <FaChevronUp /> : <FaChevronDown />}
                            </button>

                            {mostrarDetallesModal && (
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "8px", marginBottom: "14px" }}>
                                    {[
                                        { label: "Tipo Material", value: refidData?.material },
                                        { label: "Lugar", value: refidData?.lugar },
                                        { label: "Tamaño Lote", value: tamLot ? `${tamLot} t` : "---" },
                                        { label: "V. Promedio", value: cantveh },
                                        { label: "Frec. Calidad", value: frecCalidad || Math.ceil(refidData?.Planmuestreo?.frecuencia_calidad) },
                                        { label: "Frec. Granul.", value: frecGranul || Math.ceil(refidData?.Planmuestreo?.frecuencia_granulometria) },
                                        { label: "Cant. Bolsas", value: bolsa > 0 ? Math.round(bolsa) : Math.round(refidData?.bolsa) },
                                        { label: "Tamaño Mate.", value: plan?.tamano || refidData?.tamano_mate },
                                        { label: "Increm. Bolsa", value: increBolsa > 1 ? increBolsa : plan?.incremento_bolsa },
                                        { label: "Norma", value: refidData?.norma },
                                    ].map(({ label, value }, i) => (
                                        <div key={i} style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "8px 12px" }}>
                                            <p style={{ margin: 0, fontSize: "10px", color: "#718096", fontWeight: "700", textTransform: "uppercase" }}>{label}</p>
                                            <p style={{ margin: "4px 0 0", fontSize: "14px", fontWeight: "700", color: "#2d3748" }}>{value ?? "---"}</p>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Tabla de registros */}
                            <h3 className={styles.titleWithButton}>
                                Historial de Registros
                                <span style={{ fontSize: "13px", fontWeight: "400", color: "#718096", marginLeft: "8px" }}>{regsOrdenados.length} vehículos</span>
                                <button className={styles.exportButton} onClick={exportarAExcel}>
                                    <FaFileExcel className={styles.iconButton} /> Exportar
                                </button>
                            </h3>
                            <div className={styles.tableContainer}>
                                <table className={styles.tableRegistros}>
                                    <thead>
                                        <tr>
                                            <th>N°</th><th>Fecha</th><th>Hora</th><th>Placa</th>
                                            <th>Peso Neto (t)</th><th>Acumulado (t)</th>
                                            <th>Temp1</th><th>Temp2</th><th>Temp3</th><th>Temp4</th>
                                            <th>Máx</th><th>Mín</th><th>Polución</th><th>Origen</th>
                                            <th>Muestreado</th><th>Registrado</th><th>Observaciones</th><th>Foto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {regsOrdenados.reduce((acc, reg, index) => {
                                            const acumulado = acc.acumulado + Number(reg.pesoneto || 0);
                                            acc.acumulado = acumulado;
                                            const maxHigh = parseFloat(reg.MaxTemp) > 45;
                                            acc.rows.push(
                                                <tr key={index} onClick={() => handleCellClick(reg)}
                                                    style={{ cursor: "pointer", background: index % 2 === 0 ? "#fff" : "#f8fafc" }}>
                                                    <td style={{ fontWeight: "700", color: "#718096" }}>{index + 1}</td>
                                                    <td>{new Date(reg.fechacompleta).toISOString().split("T")[0]}</td>
                                                    <td>{new Date(reg.fechacompleta).toLocaleTimeString("es-ES")}</td>
                                                    <td style={{ fontWeight: "700" }}>{reg.placa || "N/A"}</td>
                                                    <td>{Number(reg.pesoneto).toFixed(2)}</td>
                                                    <td style={{ color: "#6c5dd3", fontWeight: "700" }}>{acumulado.toFixed(2)}</td>
                                                    <td>{reg.temp1}</td><td>{reg.temp2}</td><td>{reg.temp3}</td><td>{reg.temp4}</td>
                                                    <td style={maxHigh ? { color: "#e53e3e", fontWeight: "700" } : {}}>{reg.MaxTemp}</td>
                                                    <td>{reg.MinTemp}</td><td>{reg.polucion}</td><td>{reg.origenparal}</td>
                                                    <td>{reg.nombre_usuario_m}</td><td>{reg.nombre_usuario_r}</td>
                                                    <td>{reg.observaciones || "Ninguna"}</td>
                                                    <td>
                                                        {reg.fototick ? (
                                                            <img src={`https://reporte.incolabcolombia.com.co/${reg.fototick}`}
                                                                alt="Foto"
                                                                style={{ width: "50px", height: "50px", objectFit: "cover", cursor: "pointer", borderRadius: "4px" }}
                                                                onClick={(e) => { e.stopPropagation(); setImagenSeleccionada(reg.fototick); }} />
                                                        ) : "Sin foto"}
                                                    </td>
                                                </tr>
                                            );
                                            return acc;
                                        }, { acumulado: 0, rows: [] }).rows}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* ═══ Modal Edición ═══ */}
            {editRegistro && (
                <div className={styles.editModalOverlay}>
                    <div className={styles.editModal}>
                        <button className={styles.editCloseButton} onClick={handleCloseEditModal}>X</button>
                        <h2>Editar Registro</h2>
                        <form onSubmit={handleSaveEdit}>
                            <label>Placa: <input type="text" value={editRegistro.placa || ""} onChange={(e) => setEditRegistro({ ...editRegistro, placa: e.target.value })} /></label>
                            <label>Peso Neto (t): <input type="number" value={editRegistro.pesoneto} onChange={(e) => setEditRegistro({ ...editRegistro, pesoneto: e.target.value })} /></label>
                            <label>Muestreador: <input type="text" value={editRegistro.Idusuariom || ""} onChange={(e) => setEditRegistro({ ...editRegistro, Idusuariom: e.target.value })} /></label>
                            <label>Observaciones: <textarea value={editRegistro.observaciones || ""} onChange={(e) => setEditRegistro({ ...editRegistro, observaciones: e.target.value })} /></label>
                            <button type="submit" className={styles.editSaveButton}>Actualizar</button>
                            <button type="button" className={styles.editDeleteButton}>Eliminar</button>
                        </form>
                    </div>
                </div>
            )}

            {/* ═══ Modal Agregar Datos al Lote (vehículo) ═══ */}
            {showAgregarDatosModal && selectedLote && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modal} style={{ maxWidth: "580px" }}>
                        <div className={styles.encabezadoModal}>
                            <button className={styles.closeButton} onClick={() => setShowAgregarDatosModal(false)}>X</button>
                            <h2>Agregar Vehículo — Lote {selectedLote.lote}{selectedLote.paral === 1 ? ` (${selectedLote.origenparal})` : ""}</h2>
                        </div>
                        <form onSubmit={handleAgregarDatos} style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "12px" }}>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                {[
                                    { label: "Placa *", key: "placa", type: "text", required: true, transform: v => v.toUpperCase() },
                                    { label: "Peso Neto (t) *", key: "pesoneto", type: "number", required: true, step: "0.01" },
                                    { label: "Temp 1", key: "temp1", type: "number" },
                                    { label: "Temp 2", key: "temp2", type: "number" },
                                    { label: "Temp 3", key: "temp3", type: "number" },
                                    { label: "Temp 4", key: "temp4", type: "number" },
                                ].map(({ label, key, type, required, step, transform }) => (
                                    <div key={key}>
                                        <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>{label}</label>
                                        <input
                                            type={type} required={required} step={step}
                                            style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}
                                            value={nuevosDatosLote[key]}
                                            onChange={(e) => setNuevosDatosLote({ ...nuevosDatosLote, [key]: transform ? transform(e.target.value) : e.target.value })}
                                        />
                                    </div>
                                ))}
                                <div>
                                    <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Polución</label>
                                    <select
                                        style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}
                                        value={nuevosDatosLote.polucion}
                                        onChange={(e) => setNuevosDatosLote({ ...nuevosDatosLote, polucion: e.target.value })}
                                    >
                                        <option value="Normal">Normal</option>
                                        <option value="Alta">Alta</option>
                                        <option value="Baja">Baja</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Muestreador *</label>
                                    <select
                                        required
                                        style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}
                                        value={nuevosDatosLote.Idusuariom}
                                        onChange={(e) => setNuevosDatosLote({ ...nuevosDatosLote, Idusuariom: e.target.value })}
                                    >
                                        <option value="">Seleccione</option>
                                        {muestreadores.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                                    </select>
                                </div>
                                <div style={{ gridColumn: "span 2" }}>
                                    <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Observaciones</label>
                                    <textarea
                                        style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1", minHeight: "60px", resize: "vertical" }}
                                        value={nuevosDatosLote.observaciones}
                                        onChange={(e) => setNuevosDatosLote({ ...nuevosDatosLote, observaciones: e.target.value })}
                                    />
                                </div>
                                <div style={{ gridColumn: "span 2" }}>
                                    <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Foto Ticket</label>
                                    <input type="file" style={{ width: "100%", padding: "4px" }}
                                        onChange={(e) => setFotoAgDatos(e.target.files[0])} />
                                </div>
                            </div>
                            <button
                                type="submit"
                                style={{ background: "linear-gradient(135deg, #6c5dd3, #4f46e5)", color: "white", padding: "12px", borderRadius: "8px", border: "none", fontWeight: "700", fontSize: "16px", cursor: "pointer", marginTop: "8px" }}
                            >
                                ✅ Registrar Vehículo
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {/* ═══ Modal Imagen Ampliada ═══ */}
            {imagenSeleccionada && (
                <div className={styles.modalOverlay} onClick={() => setImagenSeleccionada(null)}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <img src={`https://reporte.incolabcolombia.com.co/${imagenSeleccionada}`} alt="Imagen ampliada" className={styles.imagenAmpliada} />
                        <button className={styles.closeBtn} onClick={() => setImagenSeleccionada(null)}>Cerrar</button>
                    </div>
                </div>
            )}


            {/* ═══ Modal Agregar Nuevo Lote ═══ */}
            {showAgregarLoteModal && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modal} style={{ maxWidth: "600px" }}>
                        <div className={styles.encabezadoModal}>
                            <button className={styles.closeButton} onClick={() => setShowAgregarLoteModal(false)}>X</button>
                            <h2>Agregar Nuevo Lote</h2>
                        </div>
                        <form onSubmit={handleAgregarNuevoLote} style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "12px" }}>
                            {/* Sección Origen */}
                            <div style={{ background: "#f8fafc", padding: "12px", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                    <label style={{ fontWeight: "600" }}>¿Es un lote paralelo?</label>
                                    <input type="checkbox" style={{ width: "18px", height: "18px" }} checked={nuevoLoteData.agregarParalelo}
                                        onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, agregarParalelo: e.target.checked })} />
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                    <label style={{ fontWeight: "600" }}>¿Agregar nuevo origen?</label>
                                    <input type="checkbox" style={{ width: "18px", height: "18px" }} checked={nuevoLoteData.esNuevoOrigen}
                                        onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, esNuevoOrigen: e.target.checked, nom_material: "" })} />
                                </div>
                                {nuevoLoteData.esNuevoOrigen ? (
                                    <div style={{ display: "flex", gap: "8px" }}>
                                        <input type="text" placeholder="Nombre del nuevo origen"
                                            style={{ flex: 1, padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}
                                            value={nuevoLoteData.nuevoMaterial}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, nuevoMaterial: e.target.value.toUpperCase() })} />
                                        <button type="button" onClick={handleGuardarNuevoOrigen}
                                            style={{ background: "#6c5dd3", color: "white", padding: "8px 14px", borderRadius: "6px", border: "none", cursor: "pointer" }}>
                                            Guardar
                                        </button>
                                    </div>
                                ) : (
                                    <select style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}
                                        value={nuevoLoteData.nom_material}
                                        onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, nom_material: e.target.value })}>
                                        <option value="">--- Seleccione Origen ---</option>
                                        {[...new Set(materialesParalelos.map(m => m.origenparal))].map((o, i) => (
                                            <option key={i} value={o}>{o}</option>
                                        ))}
                                    </select>
                                )}
                            </div>

                            {/* Campos del formulario */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                {[
                                    { label: "Placa *", key: "placa", type: "text", required: true, transform: v => v.toUpperCase() },
                                    { label: "Peso Neto (t) *", key: "pesoneto", type: "number", required: true, step: "0.01" },
                                    { label: "Temp 1", key: "temp1", type: "number" },
                                    { label: "Temp 2", key: "temp2", type: "number" },
                                    { label: "Temp 3", key: "temp3", type: "number" },
                                    { label: "Temp 4", key: "temp4", type: "number" },
                                ].map(({ label, key, type, required, step, transform }) => (
                                    <div key={key}>
                                        <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>{label}</label>
                                        <input type={type} required={required} step={step}
                                            style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}
                                            value={nuevoLoteData[key]}
                                            onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, [key]: transform ? transform(e.target.value) : e.target.value })} />
                                    </div>
                                ))}
                                <div>
                                    <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Muestreador *</label>
                                    <select required style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1" }}
                                        value={nuevoLoteData.Idusuariom}
                                        onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, Idusuariom: e.target.value })}>
                                        <option value="">Seleccione</option>
                                        {muestreadores.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Foto Ticket</label>
                                    <input type="file" style={{ width: "100%", padding: "4px" }}
                                        onChange={(e) => setNuevaFoto(e.target.files[0])} />
                                </div>
                                <div style={{ gridColumn: "span 2" }}>
                                    <label style={{ fontWeight: "600", display: "block", marginBottom: "4px" }}>Observaciones</label>
                                    <textarea style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #cbd5e1", minHeight: "60px", resize: "vertical" }}
                                        value={nuevoLoteData.observaciones}
                                        onChange={(e) => setNuevoLoteData({ ...nuevoLoteData, observaciones: e.target.value })} />
                                </div>
                            </div>
                            <button type="submit"
                                style={{ background: "linear-gradient(135deg, #10b981, #059669)", color: "white", padding: "12px", borderRadius: "8px", border: "none", fontWeight: "700", fontSize: "16px", cursor: "pointer", marginTop: "8px" }}>
                                Iniciar Lote
                            </button>
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
};

export default DetallesInboundParalelo;
